export default () => {
  if (!document) {
    console.log("can't run alternator without document")
    return
  }

  // The images alts that are not set will be empty
  document.querySelectorAll('img:not([alt])').forEach(img => img.setAttribute('alt', ''))
}
